import { getItem } from './storage';

export const nrkContext = {
  nrkSession: nrkSession(),
};
export const environment = import.meta.env.VITE_APP_ENV;

function nrkSession() {
  return getItem<string>('session', 'nrk-session-id', crypto.randomUUID());
}
